import styled from "styled-components";

export const StyledSSRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    border-top: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0;
        border-top: none;
    }
`;
